import { PermissionsData } from 'modules/authenticate/interfaces';

export const getHeaders = (permissions?: PermissionsData) =>
  [
    {
      order: true,
      key: 'first_name',
      i18n: 'USER_NAME_KEY',
    },
    {
      order: true,
      key: 'email',
      i18n: 'Email',
    },
    {
      order: true,
      key: 'client_name',
      i18n: 'CLIENT_KEY',
    },
    {
      order: true,
      key: 'environment_name',
      i18n: 'ENVIRONMENT_KEY',
    },
    {
      order: true,
      key: 'partner_name',
      i18n: 'PARTNER_KEY',
    },
    {
      order: true,
      key: 'active',
      i18n: 'STATUS_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'created_at',
      i18n: 'CREATION_DATE_KEY',
      centerTitle: true,
    },
    {
      order: true,
      key: 'last_access',
      i18n: 'LAST_LOGIN_DATE_KEY',
      centerTitle: true,
    },
    {
      key: '',
      i18n: 'ACTIONS_KEY',
      centerTitle: true,
      hidden: !permissions?.delete_user,
    },
  ].filter(header => !header.hidden);
